class CanvasSVGDrawer {
	constructor(style = {}) {
		this._loaded = false;
		this._template = null;
		this._img = null;
		this._width = 0;
		this._height = 0;
		this._style = style;
	}

	get width() {
		return this._width;
	}

	get height() {
		return this._height;
	}

	drawToCanvas(ctx, x, y, w, h) {
		if (!h) {
			h = this._img.height;
		}
		if (!w) {
			w = this._img.width;
		}
		ctx.drawImage(this._img, x, y, w, h);
	}

	set svgTemplateString(val) {
		let templateSVG = document.createElement("div");
		templateSVG.innerHTML = val;
		for (var styleName in this._style) {

			templateSVG.children[0].style[styleName] = this._style[styleName];
		}
	
		this._template = templateSVG;
	}

	createImage(onLoad = null) {
		var DOMURL = window.URL || window.webkitURL || window;
		var img = new Image();
		var svg = new Blob([this._template.innerHTML], { type: "image/svg+xml" });
		var url = DOMURL.createObjectURL(svg);
		img.onload = () => {
			this._img = img;
			this._height = img.height;
			this._width = img.width;
			DOMURL.revokeObjectURL(url);
			if (onLoad) {
				onLoad();
			}
		};
		img.src = url;
	}
}

export default CanvasSVGDrawer;